import React, { useRef, useState, useEffect } from 'react';

import LoanDetail from '@components/ea/LoanDetail';

import SatSignPad from '@components/common/satUI/SatSignPad';
import SatButton from '@components/common/satUI/SatButton';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatRadio from '@components/common/satUI/SatRadio';
import SatInput from '@components/common/satUI/SatInput';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

const VipCustomerPopup = props => {
  const {
    contractSign,
    searchSignData,
    complete,
    signPasteData,
    searchPasteSignData,
    onSave,
    signData,
    onClickPrev,
    isPracticeMode,
    practiceSignName,
    practiceSignature,
  } = props;

  const reportId = 'app_form_etc_06';

  const canvasSignNameRef = useRef();
  const canvasSignatureRef = useRef();
  const purposeInputRef = useRef();
  const yearsRef = useRef();
  const positionRef = useRef();
  const jobDetailRef = useRef();

  const [showErrorCheckMsg, setShowErrorCheckMsg] = useState(false);

  const [pasteCheck, setPasteCheck] = useState(false); // 붙여넣기 체크 여부
  const [signNameData, setSignNameData] = useState(''); // 성명
  const [signatureData, setSignatureData] = useState(''); // 서명

  const [purposeCheck, setPurposeCheck] = useState(''); // 보험가입목적 check
  const [purposeText, setPurposeText] = useState(''); // 보험가입목적 text
  const [purposeNote, setPurposeNote] = useState(''); // 보험가입목적 구체적인 동기 or 추가정보
  const [incomeData, setIncomeData] = useState(Array(5).fill('')); // 소득
  const [workType, setWorkType] = useState(''); // 근무형태 -> 0:사업주, 1:임직원
  const [workDetailType, setWorkDetailType] = useState(Array(4).fill('')); // 근무형태 (근속연수, 구체적인 업무, 직위)
  const [assetType, setAssetType] = useState(Array(3).fill('')); // 자산상태(금융자산/순자산/총부채)
  const [loanInfo, setLoanInfo] = useState([]); // 대출정보
  const [realEstate, setRealEstate] = useState(Array(4).fill('')); // 부동산

  const [ownerInfo, setOwnerInfo] = useState(Array(8).fill('')); // 사업주 정보
  const [ownerLoanInfo, setOwnerLoanInfo] = useState([]); // 사업주 대출정보
  const [revenue, setRevenue] = useState(Array(3).fill('')); // 사업주 매출액
  const [netIncome, setNetIncome] = useState(Array(3).fill('')); // 사업주 당기순이익

  const [planMemo, setPlanMemo] = useState(''); // 특정 사업계획이나 우발채무에 관한 기술
  const [corporationCheck, setCorporationCheck] = useState(false); // 법인계약확인서로 대체

  const purposeRadioData = [
    { label: '가족소득보장', value: '0' },
    { label: '사업보장', value: '1' },
    { label: '상속세 재원 마련', value: '2' },
    { label: '기타', value: '3' },
  ];
  const isValidIncomeThisYear =
    parseInt(incomeData[0]) > 0 && parseInt(incomeData[1]) > 0;

  useEffect(() => {
    if (
      complete &&
      (!signData.app_form_etc_06_signid_01 ||
        !signData.app_form_etc_06_signid_02)
    ) {
      // 완료된 페이지의 경우 기존 저장된 서명데이터 조회
      !isPracticeMode &&
        searchSignData(
          reportId,
          `${reportId}_signid_02`,
          `${reportId}_signid_01`,
        );
    }

    if (complete) {
      initData();
    } else {
      setLoanInfo([{ name: '', date: '', price: '' }]);
      setOwnerLoanInfo([{ name: '', date: '', price: '' }]);
    }
  }, []);

  const initData = () => {
    // 기존 저장된 data setting
    setPurposeCheck(contractSign.q1);
    setPurposeText(contractSign.q1_1);
    setPurposeNote(contractSign.q2);
    setIncomeData(contractSign.q3);
    setWorkType(contractSign.q4_1);
    setWorkDetailType(contractSign.q4);
    setAssetType(contractSign.q5.filter((value, index) => index < 3));
    setRealEstate(contractSign.q6);

    if (contractSign.q5[3] !== '') {
      // 대출정보
      const loanArr = [];
      loanArr.push({
        name: contractSign.q5[3],
        date: contractSign.q5[4],
        price: contractSign.q5[5],
      });

      if (contractSign.q5[6] !== '') {
        loanArr.push({
          name: contractSign.q5[6],
          date: contractSign.q5[7],
          price: contractSign.q5[8],
        });
      }
      setLoanInfo(loanArr);
    } else {
      setLoanInfo([{ name: '', date: '', price: '' }]);
    }

    if (contractSign.q4_1 === '0') {
      // 사업주
      setOwnerInfo(contractSign.q7.filter((value, index) => index < 8));
      setRevenue(
        contractSign.q7.filter((value, index) => index > 13 && index < 17),
      );
      setNetIncome(contractSign.q7.filter((value, index) => index > 16));
      setPlanMemo(contractSign.q8);
      setCorporationCheck(contractSign.q9);

      if (contractSign.q7[8] !== '') {
        // 대출정보
        const loanArr = [];
        loanArr.push({
          name: contractSign.q7[8],
          date: contractSign.q7[9],
          price: contractSign.q7[10],
        });

        if (contractSign.q7[11] !== '') {
          loanArr.push({
            name: contractSign.q5[11],
            date: contractSign.q5[12],
            price: contractSign.q5[13],
          });
        }
        setOwnerLoanInfo(loanArr);
      } else {
        setOwnerLoanInfo([{ name: '', date: '', price: '' }]);
      }
    }
  };

  // 붙여넣기 서명 조회
  const handlePasteCheck = value => {
    if (value && !isPracticeMode) {
      searchPasteSignData();
    }
    setPasteCheck(value);
  };

  const handleTextArea = e => {
    if (e.target.value.length <= e.target.maxLength) {
      setPurposeNote(e.target.value);
    }
  };

  // 저장버튼
  const handleButtonClick = () => {
    if (
      purposeCheck === '' ||
      (purposeCheck === '3' && purposeText === '') ||
      workType === '' ||
      workDetailType.filter(value => value === '').length > 1 ||
      !signNameData ||
      !signatureData
    ) {
      setShowErrorCheckMsg(true);
      purposeInputRef.current && purposeInputRef.current.isValidCheck();
      yearsRef.current.isValidCheck();
      positionRef.current.isValidCheck();
      jobDetailRef.current.isValidCheck();
    } else {
      // 저장
      const saveData = {
        step: 523,
        q1: purposeCheck,
        q1_1: purposeCheck === '3' ? purposeText : '',
        q2: purposeNote,
        q3: incomeData,
        q4: workDetailType,
        q4_1: workType,
        q5: [
          assetType[0],
          assetType[1],
          assetType[2],
          loanInfo[0] ? loanInfo[0].name : '',
          loanInfo[0] ? loanInfo[0].date : '',
          loanInfo[0] ? loanInfo[0].price : '',
          loanInfo[1] ? loanInfo[1].name : '',
          loanInfo[1] ? loanInfo[1].date : '',
          loanInfo[1] ? loanInfo[1].price : '',
        ],
        q6: realEstate,
        q7: [
          workType === '0' ? ownerInfo[0] : '', //사업주 -> 회사명
          workType === '0' ? ownerInfo[1] : '', //사업주 -> 설립연도
          workType === '0' ? ownerInfo[2] : '', //사업주 -> 총임직원수
          workType === '0' ? ownerInfo[3] : '', //사업주 -> 업종
          workType === '0' ? ownerInfo[4] : '', //사업주 -> 납입자본금
          workType === '0' ? ownerInfo[5] : '', //사업주 -> 지분
          workType === '0' ? ownerInfo[6] : '', //사업주 -> 총자산
          workType === '0' ? ownerInfo[7] : '', //사업주 -> 총부채
          workType === '0' && ownerLoanInfo[0] ? ownerLoanInfo[0].name : '', //사업주 -> 대출기관명1
          workType === '0' && ownerLoanInfo[0] ? ownerLoanInfo[0].date : '', //사업주 -> 대출발생일1
          workType === '0' && ownerLoanInfo[0] ? ownerLoanInfo[0].price : '', //사업주 -> 대출금액1
          workType === '0' && ownerLoanInfo[1] ? ownerLoanInfo[1].name : '', //사업주 -> 대출기관명2
          workType === '0' && ownerLoanInfo[1] ? ownerLoanInfo[1].date : '', //사업주 -> 대출발생일2
          workType === '0' && ownerLoanInfo[1] ? ownerLoanInfo[1].price : '', //사업주 -> 대출금액2
          workType === '0' ? revenue[0] : '', //매출액 1년전
          workType === '0' ? revenue[1] : '', //매출액 2년전
          workType === '0' ? revenue[2] : '', //매출액 3년전
          workType === '0' ? netIncome[0] : '', //당기순이익 1년전
          workType === '0' ? netIncome[1] : '', //당기순이익 2년전
          workType === '0' ? netIncome[2] : '', //당기순이익 3년전
        ],
        q8: workType === '0' ? planMemo : '', //사업주 -> 특정 사업계획이나 우발채무에 관한 기술
        q9: workType === '0' ? corporationCheck : '', //사업주 -> 법인계약확인서로 대체
      };

      onSave(
        saveData,
        signNameData,
        signatureData,
        reportId,
        `${reportId}_signid_02`,
        `${reportId}_signid_01`,
      );
    }
  };

  // 대출정보 삭제
  const handleLoanDetailDelete = findIndex => {
    setLoanInfo(loanInfo.filter((value, index) => index !== findIndex));
  };

  // 사업주 대출정보 삭제
  const handleOwnerLoanDetailDelete = findIndex => {
    setOwnerLoanInfo(
      ownerLoanInfo.filter((value, index) => index !== findIndex),
    );
  };

  // 대출정보 등록
  const handleLoanDetailAdd = () => {
    let resultData = loanInfo.map(item => {
      return item;
    });

    resultData.push({ name: '', date: '', price: '' });
    setLoanInfo(resultData);
  };

  // 사업주 대출정보 등록
  const handleOwnerLoanDetailAdd = () => {
    let resultData = ownerLoanInfo.map(item => {
      return item;
    });

    resultData.push({ name: '', date: '', price: '' });
    setOwnerLoanInfo(resultData);
  };

  // 대출정보 변경
  const handleLoanDetailOnChange = (index, changeData) => {
    const resultData = loanInfo.map((item, findIndex) => {
      return findIndex === index ? changeData : item;
    });

    setLoanInfo(resultData);
  };

  // 사업주 대출정보 변경
  const handleOwnerLoanDetailOnChange = (index, changeData) => {
    const resultData = ownerLoanInfo.map((item, findIndex) => {
      return findIndex === index ? changeData : item;
    });

    setOwnerLoanInfo(resultData);
  };

  return (
    <React.Fragment>
      <header className="con-header">
        <div className="page-navi">
          <SatButton
            styleClass={`btn-back`}
            label={'이전'}
            onClick={() => onClickPrev()}
          />
        </div>
        <h1 className="page-tit">VIP 고객 확인서</h1>
      </header>

      <div className="con-wrap">
        <div className="pop-box">
          <div className="info-box bg-yellow">
            <p className="text-info3">
              아래 재정질문사항은 청약의 인수여부를 판단하는 목적으로 사용되므로
              재정질문사항에 대해 사실대로 기재하여주시기 바랍니다.
            </p>
          </div>
          <div className="infor-list">
            <h2 className="tit-con">작성자</h2>
            <div className="check-box">
              <SatRadio
                value={true}
                options={[
                  {
                    label: '계약자/피보험자',
                    value: true,
                  },
                ]}
                name="writer"
              />
            </div>
          </div>
          <div className="infor-list">
            <h2 className="tit-con">보험가입목적</h2>
            <div className="check-box">
              {purposeRadioData.map(option => {
                return (
                  <>
                    <SatRadio
                      value={purposeCheck}
                      options={[
                        {
                          label: option.label,
                          value: option.value,
                        },
                      ]}
                      onChange={value => setPurposeCheck(value.value)}
                      name="purposeCheck"
                    />
                  </>
                );
              })}
            </div>
            <SatValidationErrMsg
              visible={showErrorCheckMsg && purposeCheck === ''}
              type="error"
              message="내용을 확인하고 선택해 주세요."
            />
            <div className="w100 block mgb-20">
              {purposeCheck === '3' && (
                <SatInput
                  ref={purposeInputRef}
                  type="text"
                  value={purposeText}
                  label={'기타사항입력'}
                  onChange={value => setPurposeText(value)}
                  validRule={[
                    {
                      required: true,
                      errMsg: '내용을 확인하고 입력해 주세요.',
                    },
                  ]}
                  maxLength={30}
                />
              )}
            </div>
            <p className="text-con mgb-16">
              구체적인 청약 동기, 그 외 심사 시 참조할만한 추가 정보가 있는 경우
              내용을 입력해 주세요.
            </p>
            <div className="txtarea-wrap mgb-20">
              <textarea
                className="txtarea"
                maxLength="50"
                style={{ height: '9.6rem' }}
                placeholder="청약동기, 추가사항 입력사항을 50자 이내로 입력해주세요."
                value={purposeNote}
                onChange={handleTextArea}
              />
              <span className="max-length">{`(${purposeNote.length}/50)`}</span>
            </div>
          </div>
          <div className="infor-list">
            <h2 className="tit-con">소득명세</h2>
            <div className="insu-box">
              <table className="medi-history">
                <caption>정보선택</caption>
                <colgroup>
                  <col style={{ width: '13rem' }} />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">연간 근로(사업)소득</th>
                    <td>
                      <div className="check-box inp-number mg-0">
                        <div className="item-w50">
                          <div className="amount">
                            <p className="text-info4">전년도</p>
                            <SatInput
                              value={incomeData[0] === '' ? '0' : incomeData[0]}
                              type={'currency'}
                              dataIndex={'faceAmount'}
                              outerSuffix={() => (
                                <span className="txt">만원</span>
                              )}
                              currencyType="W"
                              validRule={[
                                {
                                  rule: v => v.replace(/,/g, '').length <= 8,
                                  errMsg: '8자리 이하로 입력해주세요.',
                                },
                              ]}
                              onChange={value => {
                                if (value.replaceAll(',', '').length <= 8) {
                                  setIncomeData(
                                    incomeData.map((item, index) => {
                                      return 0 === index ? value : item;
                                    }),
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="item-w50">
                          <div className="amount">
                            <p className="text-info4">당년도</p>
                            <SatInput
                              value={incomeData[1] === '' ? '0' : incomeData[1]}
                              type={'currency'}
                              dataIndex={'faceAmount'}
                              outerSuffix={() => (
                                <span className="txt">만원</span>
                              )}
                              currencyType="W"
                              validRule={[
                                {
                                  rule: v => v.replace(/,/g, '').length <= 8,
                                  errMsg: '8자리 이하로 입력해주세요.',
                                },
                              ]}
                              onChange={value => {
                                if (value.replaceAll(',', '').length <= 8) {
                                  setIncomeData(
                                    incomeData.map((item, index) => {
                                      return 1 === index ? value : item;
                                    }),
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">기타소득 (선택)</th>
                    <td>
                      <div className="check-box inp-number mg-0">
                        <div className="item-w50">
                          <div className="amount">
                            <p className="text-info4">전년도</p>
                            <SatInput
                              value={incomeData[2] === '' ? '0' : incomeData[2]}
                              type={'currency'}
                              dataIndex={'faceAmount'}
                              outerSuffix={() => (
                                <span className="txt">만원</span>
                              )}
                              currencyType="W"
                              validRule={[
                                {
                                  rule: v => v.replace(/,/g, '').length <= 8,
                                  errMsg: '8자리 이하로 입력해주세요.',
                                },
                              ]}
                              onChange={value => {
                                if (value.replaceAll(',', '').length <= 8) {
                                  setIncomeData(
                                    incomeData.map((item, index) => {
                                      return 2 === index ? value : item;
                                    }),
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="item-w50">
                          <div className="amount">
                            <p className="text-info4">당년도</p>
                            <SatInput
                              value={incomeData[3] === '' ? '0' : incomeData[3]}
                              type={'currency'}
                              dataIndex={'faceAmount'}
                              outerSuffix={() => (
                                <span className="txt">만원</span>
                              )}
                              currencyType="W"
                              validRule={[
                                {
                                  rule: v => v.replace(/,/g, '').length <= 8,
                                  errMsg: '8자리 이하로 입력해주세요.',
                                },
                              ]}
                              onChange={value => {
                                if (value.replaceAll(',', '').length <= 8) {
                                  setIncomeData(
                                    incomeData.map((item, index) => {
                                      return 3 === index ? value : item;
                                    }),
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mgb-20">
              <div className="txtarea-wrap">
                <textarea
                  className="txtarea"
                  maxLength="44"
                  style={{ height: '9.6rem' }}
                  placeholder="기타 소득의 상세 내용 입력"
                  value={incomeData[4]}
                  onChange={e => {
                    if (e.target.value.length <= 44) {
                      setIncomeData(
                        incomeData.map((item, index) => {
                          return 4 === index ? e.target.value : item;
                        }),
                      );
                    }
                  }}
                />
                <span className="max-length">{`(${purposeNote.length}/44)`}</span>
              </div>
            </div>
          </div>
          <div className="infor-list">
            <h2 className="tit-con">근무형태</h2>
            <div className="insu-box">
              <table className="medi-history">
                <caption>정보선택</caption>
                <colgroup>
                  <col style={{ width: '10rem' }} />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">직종</th>
                    <td colSpan="3">
                      <div className="check-box">
                        <SatRadio
                          value={workType}
                          options={[
                            {
                              label: '사업주',
                              value: '0',
                            },
                            {
                              label: '임직원',
                              value: '1',
                            },
                          ]}
                          onChange={value => setWorkType(value.value)}
                          name="workType"
                        />
                      </div>
                      <SatValidationErrMsg
                        visible={showErrorCheckMsg && workType === ''}
                        type="error"
                        message="내용을 확인하고 선택해 주세요."
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">근속연수</th>
                    <td>
                      <div className="contract-info w-180 text-left mg-0">
                        <div className="amount">
                          <SatInput
                            ref={yearsRef}
                            type="number"
                            value={workDetailType[1]}
                            placeholder="입력"
                            maxLength={2}
                            outerSuffix={() => <span className="txt">년</span>}
                            onChange={value =>
                              setWorkDetailType(
                                workDetailType.map((item, index) => {
                                  return 1 === index ? value : item;
                                }),
                              )
                            }
                            validRule={[
                              {
                                required: true,
                                errMsg: '내용을 확인하고 입력해 주세요.',
                              },
                              {
                                rule: v => v.length <= 2,
                                errMsg: '2자리 이하로 입력해주세요.',
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">직위</th>
                    <td>
                      <SatInput
                        ref={positionRef}
                        type="text"
                        value={workDetailType[3]}
                        placeholder="입력"
                        onChange={value => {
                          if (value.length <= 15) {
                            setWorkDetailType(
                              workDetailType.map((item, index) => {
                                return 3 === index ? value : item;
                              }),
                            );
                          }
                        }}
                        validRule={[
                          {
                            required: true,
                            errMsg: '내용을 확인하고 입력해 주세요.',
                          },
                        ]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">구체적인 업무</th>
                    <td>
                      <SatInput
                        ref={jobDetailRef}
                        type="text"
                        value={workDetailType[2]}
                        placeholder="입력"
                        onChange={value => {
                          if (value.length <= 24) {
                            setWorkDetailType(
                              workDetailType.map((item, index) => {
                                return 2 === index ? value : item;
                              }),
                            );
                          }
                        }}
                        validRule={[
                          {
                            required: true,
                            errMsg: '내용을 확인하고 입력해 주세요.',
                          },
                        ]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="infor-list">
            <h2 className="tit-con">자산상태 (선택)</h2>
            <div className="insu-box item-r2">
              <table className="medi-history">
                <caption>정보선택</caption>
                <colgroup>
                  <col style={{ width: '9.5rem' }} />
                  <col style={{ width: '36%' }} />
                  <col style={{ width: '9.5rem' }} />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">금융자산</th>
                    <td>
                      <div className="amount">
                        <SatInput
                          value={assetType[0] === '' ? '0' : assetType[0]}
                          type={'currency'}
                          dataIndex={'faceAmount'}
                          outerSuffix={() => <span className="txt">만원</span>}
                          currencyType="W"
                          validRule={[
                            {
                              rule: v => v.replace(/,/g, '').length <= 8,
                              errMsg: '8자리 이하로 입력해주세요.',
                            },
                          ]}
                          onChange={value => {
                            if (value.replaceAll(',', '').length <= 8) {
                              setAssetType(
                                assetType.map((item, index) => {
                                  return 0 === index ? value : item;
                                }),
                              );
                            }
                          }}
                        />
                      </div>
                    </td>
                    <th scope="row">총부채</th>
                    <td>
                      <div className="amount">
                        <SatInput
                          value={assetType[2] === '' ? '0' : assetType[2]}
                          type={'currency'}
                          dataIndex={'faceAmount'}
                          outerSuffix={() => <span className="txt">만원</span>}
                          currencyType="W"
                          validRule={[
                            {
                              rule: v => v.replace(/,/g, '').length <= 8,
                              errMsg: '8자리 이하로 입력해주세요.',
                            },
                          ]}
                          onChange={value => {
                            if (value.replaceAll(',', '').length <= 8) {
                              setAssetType(
                                assetType.map((item, index) => {
                                  return 2 === index ? value : item;
                                }),
                              );
                              if (value !== '') {
                                setLoanInfo([
                                  { name: '', date: '', price: '' },
                                ]);
                              }
                            }
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* 대출 정보 */}
          {loanInfo.length > 0 &&
            loanInfo.map((data, index) => {
              return (
                <>
                  <LoanDetail
                    index={index}
                    loanData={data}
                    totalLength={loanInfo.length}
                    deleteBtnAvailable={
                      loanInfo.length === 2 ||
                      (loanInfo.length === 1 &&
                        (assetType[2] === '' || assetType[2] === '0'))
                    }
                    onDelete={handleLoanDetailDelete}
                    onAdd={handleLoanDetailAdd}
                    onChangeData={handleLoanDetailOnChange}
                  />
                </>
              );
            })}

          <div className="infor-list">
            <h2 className="tit-con">부동산(주거형태포함) (선택)</h2>
            <div className="check-box inp-number item-r2">
              <div className="item-w50">
                <SatInput
                  type="text"
                  value={realEstate[0]}
                  label="지역"
                  maxLength={16}
                  onChange={value => {
                    if (value.length <= 16) {
                      setRealEstate(
                        realEstate.map((item, index) => {
                          return 0 === index ? value : item;
                        }),
                      );
                    }
                  }}
                />
              </div>
              <div className="item-w50">
                <SatInput
                  type="text"
                  value={realEstate[1]}
                  label="형태"
                  onChange={value => {
                    if (value.length <= 16) {
                      setRealEstate(
                        realEstate.map((item, index) => {
                          return 1 === index ? value : item;
                        }),
                      );
                    }
                  }}
                />
              </div>
            </div>
            <div className="insu-box item-r2">
              <table className="medi-history">
                <caption>정보선택</caption>
                <colgroup>
                  <col style={{ width: '5rem' }} />
                  <col style={{ width: '41%' }} />
                  <col style={{ width: '7rem' }} />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">시가</th>
                    <td>
                      <div className="amount">
                        <SatInput
                          value={realEstate[2] === '' ? '0' : realEstate[2]}
                          type={'currency'}
                          dataIndex={'faceAmount'}
                          outerSuffix={() => <span className="txt">만원</span>}
                          currencyType="W"
                          onChange={value => {
                            if (value.replaceAll(',', '').length <= 8) {
                              setRealEstate(
                                realEstate.map((item, index) => {
                                  return 2 === index ? value : item;
                                }),
                              );
                            }
                          }}
                          validRule={[
                            {
                              rule: v => v.replace(/,/g, '').length <= 8,
                              errMsg: '8자리 이하로 입력해주세요.',
                            },
                          ]}
                        />
                      </div>
                    </td>
                    <th scope="row" className="text-center">
                      융자금
                    </th>
                    <td>
                      <div className="amount">
                        <SatInput
                          value={realEstate[3] === '' ? '0' : realEstate[3]}
                          type={'currency'}
                          dataIndex={'faceAmount'}
                          outerSuffix={() => <span className="txt">만원</span>}
                          currencyType="W"
                          onChange={value => {
                            if (value.replaceAll(',', '').length <= 8) {
                              setRealEstate(
                                realEstate.map((item, index) => {
                                  return 3 === index ? value : item;
                                }),
                              );
                            }
                          }}
                          validRule={[
                            {
                              rule: v => v.replace(/,/g, '').length <= 8,
                              errMsg: '8자리 이하로 입력해주세요.',
                            },
                          ]}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {workType === '0' && (
            <>
              <div className="infor-list">
                <div className="tit-area2">
                  <h2 className="tit-con">사업주</h2>
                  <SatCheckBox
                    value={[corporationCheck]}
                    options={[{ label: '법인계약확인서로 대체', value: false }]}
                    onChange={v => setCorporationCheck(v)}
                    customStyleClass="mgl-24"
                  />
                </div>
                {!corporationCheck && (
                  <>
                    <div className="check-box inp-number item-r2">
                      <div className="item-w50 text-left">
                        <SatInput
                          type="text"
                          value={ownerInfo[0]}
                          label="회사명"
                          onChange={value => {
                            if (value.length <= 14) {
                              setOwnerInfo(
                                ownerInfo.map((item, index) => {
                                  return 0 === index ? value : item;
                                }),
                              );
                            }
                          }}
                        />
                      </div>
                      <div className="item-w50">
                        <SatInput
                          type="number"
                          value={ownerInfo[1]}
                          label="설립연도"
                          focusLabel="설립연도(4자리)"
                          maxLength={4}
                          onChange={value =>
                            setOwnerInfo(
                              ownerInfo.map((item, index) => {
                                return 1 === index ? value : item;
                              }),
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="check-box inp-number item-r2">
                      <div className="item-w50 text-left">
                        <div className="amount">
                          <SatInput
                            type="number"
                            value={ownerInfo[2]}
                            label="총 임직원 수"
                            focusLabel="총 임직원 수"
                            maxLength={6}
                            outerSuffix={() => <span className="txt">명</span>}
                            onChange={value =>
                              setOwnerInfo(
                                ownerInfo.map((item, index) => {
                                  return 2 === index ? value : item;
                                }),
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="item-w50">
                        <SatInput
                          type="text"
                          value={ownerInfo[3]}
                          label="업종"
                          onChange={value => {
                            if (value.length <= 17) {
                              setOwnerInfo(
                                ownerInfo.map((item, index) => {
                                  return 3 === index ? value : item;
                                }),
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="insu-box item-r2">
                      <table className="medi-history">
                        <caption>정보선택</caption>
                        <colgroup>
                          <col style={{ width: '7rem' }} />
                          <col style={{ width: '36%' }} />
                          <col style={{ width: '9.5rem' }} />
                          <col />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th scope="row">납입자본금</th>
                            <td>
                              <div className="amount">
                                <SatInput
                                  value={
                                    ownerInfo[4] === '' ? '0' : ownerInfo[4]
                                  }
                                  type={'currency'}
                                  dataIndex={'faceAmount'}
                                  outerSuffix={() => (
                                    <span className="txt">만원</span>
                                  )}
                                  currencyType="W"
                                  validRule={[
                                    {
                                      rule: v =>
                                        v.replace(/,/g, '').length <= 8,
                                      errMsg: '8자리 이하로 입력해주세요.',
                                    },
                                  ]}
                                  onChange={value => {
                                    if (value.replaceAll(',', '').length <= 8) {
                                      setOwnerInfo(
                                        ownerInfo.map((item, index) => {
                                          return 4 === index ? value : item;
                                        }),
                                      );
                                    }
                                  }}
                                />
                              </div>
                            </td>
                            <th scope="row" className="text-center">
                              지분
                            </th>
                            <td>
                              <div className="per">
                                <SatInput
                                  type="number"
                                  value={ownerInfo[5]}
                                  focusLabel="지분"
                                  maxLength={3}
                                  outerSuffix={() => (
                                    <span className="txt">%</span>
                                  )}
                                  onChange={value =>
                                    setOwnerInfo(
                                      ownerInfo.map((item, index) => {
                                        return 5 === index ? value : item;
                                      }),
                                    )
                                  }
                                  validRule={[
                                    {
                                      rule: v => parseInt(v) <= 100,
                                      errMsg: '100 이하로 입력해주세요.',
                                    },
                                  ]}
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">총자산</th>
                            <td>
                              <div className="amount">
                                <SatInput
                                  value={
                                    ownerInfo[6] === '' ? '0' : ownerInfo[6]
                                  }
                                  type={'currency'}
                                  dataIndex={'faceAmount'}
                                  outerSuffix={() => (
                                    <span className="txt">만원</span>
                                  )}
                                  currencyType="W"
                                  validRule={[
                                    {
                                      rule: v =>
                                        v.replace(/,/g, '').length <= 8,
                                      errMsg: '8자리 이하로 입력해주세요.',
                                    },
                                  ]}
                                  onChange={value => {
                                    if (value.replaceAll(',', '').length <= 8) {
                                      setOwnerInfo(
                                        ownerInfo.map((item, index) => {
                                          return 6 === index ? value : item;
                                        }),
                                      );
                                    }
                                  }}
                                />
                              </div>
                            </td>
                            <th scope="row" className="text-center">
                              총부채
                            </th>
                            <td>
                              <div className="amount">
                                <SatInput
                                  value={
                                    ownerInfo[7] === '' ? '0' : ownerInfo[7]
                                  }
                                  type={'currency'}
                                  dataIndex={'faceAmount'}
                                  outerSuffix={() => (
                                    <span className="txt">만원</span>
                                  )}
                                  currencyType="W"
                                  validRule={[
                                    {
                                      rule: v =>
                                        v.replace(/,/g, '').length <= 8,
                                      errMsg: '8자리 이하로 입력해주세요.',
                                    },
                                  ]}
                                  onChange={value => {
                                    if (value.replaceAll(',', '').length <= 8) {
                                      setOwnerInfo(
                                        ownerInfo.map((item, index) => {
                                          return 7 === index ? value : item;
                                        }),
                                      );
                                    }
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>

              {!corporationCheck && (
                <>
                  {/* 사업주 대출 정보 */}
                  {ownerLoanInfo.length > 0 &&
                    ownerLoanInfo.map((data, index) => {
                      return (
                        <>
                          <LoanDetail
                            index={index}
                            loanData={data}
                            totalLength={ownerLoanInfo.length}
                            deleteBtnAvailable={
                              ownerLoanInfo.length === 2 ||
                              (ownerLoanInfo.length === 1 &&
                                (ownerInfo[7] === '' || ownerInfo[7] === '0'))
                            }
                            onDelete={handleOwnerLoanDetailDelete}
                            onAdd={handleOwnerLoanDetailAdd}
                            onChangeData={handleOwnerLoanDetailOnChange}
                          />
                        </>
                      );
                    })}

                  <div className="infor-list">
                    <h2 className="tit-con">매출 및 당기순이익</h2>
                    <div className="insu-box">
                      <table className="medi-history">
                        <caption>정보선택</caption>
                        <colgroup>
                          <col style={{ width: '9.5rem' }} />
                          <col />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th scope="row" rowSpan="2">
                              매출액
                            </th>
                            <td>
                              <div className="check-box inp-number mg-0">
                                <div className="item-w50">
                                  <div className="amount">
                                    <p className="text-info4">1년전</p>
                                    <SatInput
                                      value={
                                        revenue[0] === '' ? '0' : revenue[0]
                                      }
                                      type={'currency'}
                                      currencyType="W"
                                      validRule={[
                                        {
                                          rule: v =>
                                            v.replace(/,/g, '').length <= 8,
                                          errMsg: '8자리 이하로 입력해주세요.',
                                        },
                                      ]}
                                      outerSuffix={() => (
                                        <span className="txt">만원</span>
                                      )}
                                      onChange={value => {
                                        if (
                                          value.replaceAll(',', '').length <= 8
                                        ) {
                                          setRevenue(
                                            revenue.map((item, index) => {
                                              return 0 === index ? value : item;
                                            }),
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="item-w50">
                                  <div className="amount">
                                    <p className="text-info4">2년전</p>
                                    <SatInput
                                      value={
                                        revenue[1] === '' ? '0' : revenue[1]
                                      }
                                      type={'currency'}
                                      currencyType="W"
                                      validRule={[
                                        {
                                          rule: v =>
                                            v.replace(/,/g, '').length <= 8,
                                          errMsg: '8자리 이하로 입력해주세요.',
                                        },
                                      ]}
                                      outerSuffix={() => (
                                        <span className="txt">만원</span>
                                      )}
                                      onChange={value => {
                                        if (
                                          value.replaceAll(',', '').length <= 8
                                        ) {
                                          setRevenue(
                                            revenue.map((item, index) => {
                                              return 1 === index ? value : item;
                                            }),
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="check-box inp-number mg-0">
                                <div className="item-w50">
                                  <div className="amount">
                                    <p className="text-info4">3년전</p>
                                    <SatInput
                                      value={
                                        revenue[2] === '' ? '0' : revenue[2]
                                      }
                                      type={'currency'}
                                      currencyType="W"
                                      validRule={[
                                        {
                                          rule: v =>
                                            v.replace(/,/g, '').length <= 8,
                                          errMsg: '8자리 이하로 입력해주세요.',
                                        },
                                      ]}
                                      outerSuffix={() => (
                                        <span className="txt">만원</span>
                                      )}
                                      onChange={value => {
                                        if (
                                          value.replaceAll(',', '').length <= 8
                                        ) {
                                          setRevenue(
                                            revenue.map((item, index) => {
                                              return 2 === index ? value : item;
                                            }),
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="insu-box">
                      <table className="medi-history">
                        <caption>정보선택</caption>
                        <colgroup>
                          <col style={{ width: '9.5rem' }} />
                          <col />
                        </colgroup>

                        <tbody>
                          <tr>
                            <th scope="row" rowSpan="2">
                              당기 순이익
                            </th>
                            <td>
                              <div className="check-box inp-number mg-0">
                                <div className="item-w50">
                                  <div className="amount">
                                    <p className="text-info4">1년전</p>
                                    <SatInput
                                      value={
                                        netIncome[0] === '' ? '0' : netIncome[0]
                                      }
                                      type={'currency'}
                                      currencyType="W"
                                      validRule={[
                                        {
                                          rule: v =>
                                            v.replace(/,/g, '').length <= 8,
                                          errMsg: '8자리 이하로 입력해주세요.',
                                        },
                                      ]}
                                      outerSuffix={() => (
                                        <span className="txt">만원</span>
                                      )}
                                      onChange={value => {
                                        if (
                                          value.replaceAll(',', '').length <= 8
                                        ) {
                                          setNetIncome(
                                            netIncome.map((item, index) => {
                                              return 0 === index ? value : item;
                                            }),
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="item-w50">
                                  <div className="amount">
                                    <p className="text-info4">2년전</p>
                                    <SatInput
                                      value={
                                        netIncome[1] === '' ? '0' : netIncome[1]
                                      }
                                      type={'currency'}
                                      currencyType="W"
                                      validRule={[
                                        {
                                          rule: v =>
                                            v.replace(/,/g, '').length <= 8,
                                          errMsg: '8자리 이하로 입력해주세요.',
                                        },
                                      ]}
                                      outerSuffix={() => (
                                        <span className="txt">만원</span>
                                      )}
                                      onChange={value => {
                                        if (
                                          value.replaceAll(',', '').length <= 8
                                        ) {
                                          setNetIncome(
                                            netIncome.map((item, index) => {
                                              return 1 === index ? value : item;
                                            }),
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="check-box inp-number mg-0">
                                <div className="item-w50">
                                  <div className="amount">
                                    <p className="text-info4">3년전</p>
                                    <SatInput
                                      value={
                                        netIncome[2] === '' ? '0' : netIncome[2]
                                      }
                                      type={'currency'}
                                      currencyType="W"
                                      validRule={[
                                        {
                                          rule: v =>
                                            v.replace(/,/g, '').length <= 8,
                                          errMsg: '8자리 이하로 입력해주세요.',
                                        },
                                      ]}
                                      outerSuffix={() => (
                                        <span className="txt">만원</span>
                                      )}
                                      onChange={value => {
                                        if (
                                          value.replaceAll(',', '').length <= 8
                                        ) {
                                          setNetIncome(
                                            netIncome.map((item, index) => {
                                              return 2 === index ? value : item;
                                            }),
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="infor-list">
                    <h2 className="tit-con">기타 (선택)</h2>
                    <p className="text-con mgb-16">
                      특정 사업계획이나 우발채무에 관해 입력해주세요.
                    </p>
                    <div className="txtarea-wrap mgb-20">
                      <textarea
                        className="txtarea"
                        maxLength="50"
                        style={{ height: '9.6rem' }}
                        placeholder="50자 이내로 입력해주세요."
                        value={planMemo}
                        onChange={e => {
                          e.target.value.length <= 50 &&
                            setPlanMemo(e.target.value);
                        }}
                      />
                      <span className="max-length">{`(${planMemo.length}/50)`}</span>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          <div className="info-box bg-yellow">
            <p className="text-info3">
              위 내용은 사실과 다름이 없음을 확인합니다.
            </p>
          </div>
          <SatCheckBox
            value={[pasteCheck]}
            type={'radio'}
            options={[
              { label: '저장했던 성명/서명을 붙여넣으세요.', value: false },
            ]}
            onChange={v => handlePasteCheck(v)}
            customStyleClass="small w-360"
          />
          <div className="sign-pad-wrap">
            <SatSignPad
              canvasRef={canvasSignNameRef}
              name={'작성자 성명'}
              title={'작성자 성명 입력'}
              error={
                showErrorCheckMsg && !signNameData ? '성명을 입력해주세요.' : ''
              }
              pasteCheck={pasteCheck}
              pasteData={
                !isPracticeMode
                  ? signPasteData.app_form_etc_18_sign_01
                  : practiceSignName
              }
              signData={complete ? signData.app_form_etc_06_signid_01 : ''}
              onChange={value => setSignNameData(value)}
              onChangePasteCheck={value => setPasteCheck(value)}
            />
            <SatSignPad
              canvasRef={canvasSignatureRef}
              name={'작성자 서명'}
              title={'작성자 서명 입력'}
              error={
                showErrorCheckMsg && !signatureData
                  ? '서명을 입력해주세요.'
                  : ''
              }
              pasteCheck={pasteCheck}
              pasteData={
                !isPracticeMode
                  ? signPasteData.app_form_etc_18_sign_02
                  : practiceSignature
              }
              signData={complete ? signData.app_form_etc_06_signid_02 : ''}
              onChange={value => setSignatureData(value)}
              onChangePasteCheck={value => setPasteCheck(value)}
            />
          </div>
        </div>
      </div>

      <div className="con-bottom box-shadow">
        <div className="btn-area">
          <div className="box-btns-center">
            <SatButton
              styleClass={`btn-s blue btn-wide ${
                purposeCheck === '' ||
                (purposeCheck === '3' && purposeText === '') ||
                workType === '' ||
                workDetailType.filter(value => value === '').length > 1 ||
                !signNameData ||
                !signatureData ||
                !isValidIncomeThisYear
                  ? 'disabled'
                  : ''
              }`}
              label={'확인'}
              onClick={() => handleButtonClick()}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VipCustomerPopup;
